module.exports = __webpack_public_path__ + "static/media/Permias Bloomington.c30b9cd7.jpg";